module.exports = __webpack_public_path__ + "img/badge_example.c4c4519a.png";